import { isKindeAppleMigrationAvailable } from '@/utils/appConfiguration';
import { isKindeProvider } from '@/utils/auth/isKindeProvider';
import { type AuthProvider } from '@/utils/auth/persistedAuthProvider';

export function computeIsEligibleForKindeMigrationModal({
  appleMigrationStatus,
  authProvider,
}: {
  appleMigrationStatus: string | null | undefined;
  authProvider: AuthProvider | undefined | null;
}): boolean {
  return (
    (appleMigrationStatus === 'ticket_created' ||
      appleMigrationStatus === 'ticket_refreshed') &&
    isKindeProvider(authProvider) &&
    isKindeAppleMigrationAvailable()
  );
}
